import { makeStyles } from "@material-ui/core";
import { Colors } from "../../../../../utils";

const makeClasses = makeStyles((theme) => ({
  gridTitleContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    color: Colors.rgb.contentTextHighlighted,

    "& > div": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",

      "& > span": {
        "&:nth-child(2)": {
          fontFamily: theme.fontFamily.bold,
          marginLeft: theme.spacing(1),
        },
        "&:nth-child(3)": {
          fontFamily: theme.fontFamily.regular,
          margin: `0 ${theme.spacing(2)}`,
        },
        "&:nth-child(5)": {
          fontFamily: theme.fontFamily.bold,
          marginLeft: theme.spacing(1),
        },
      },
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",

      "& > div": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",

        "&:nth-child(1)": {
          "& > span": {
            fontFamily: theme.fontFamily.bold,
            marginLeft: `0 !important`,
            fontSize: theme.fontSize.L,
            display: "block",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            width: "calc(100% - 20px)",
            overflow: "hidden",
          },
        },
        "&:nth-child(2)": {
          justifyContent: "flex-end",
          marginTop: theme.spacing(1),

          "& > span": {
            fontFamily: `${theme.fontFamily.bold} !important`,
            marginLeft: theme.spacing(1),
            fontSize: theme.fontSize.M,

            "&:nth-child(1)": {
              fontFamily: `${theme.fontFamily.regular} !important`,
            },

            "&:nth-child(3)": {
              marginRight: 0,
              marginLeft: theme.spacing(1),
            },
          },
        },
      },
    },
  },
  gridTitleIcon: {
    width: 20,
    marginRight: theme.spacing(1),
  },
  viewFilterWrapper: {
    display: "flex",
    alignItems: "center",

    "& > div:nth-child(1)": {
      color: Colors.rgb.contentTextHighlighted,
      fontSize: theme.fontSize.XL,
      fontFamily: theme.fontFamily.bold,
      marginRight: theme.spacing(4),
    },
  },
  gridTitleWrapper: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",

    "& > div": {
      display: "flex",
      alignItems: "center",

      "&:nth-child(1)": {
        "& > div:nth-child(1)": {
          color: Colors.rgb.contentTextHighlighted,
          fontSize: theme.fontSize.XL,
          fontFamily: theme.fontFamily.bold,
          marginRight: theme.spacing(4),

          [theme.breakpoints.down("sm")]: {
            fontSize: theme.fontSize.M,
            marginRight: theme.spacing(2),
          },
        },
      },
    },
  },
  gridWrapper: {
    marginTop: theme.spacing(3),
  },
  gridSeparator: {
    background: Colors.rgb.contentLine,
    height: 1,
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  suscriptionDetailsItem: {
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentTextHighlighted,
    fontSize: theme.fontSize.L,
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordWrap: "break-word",

    "& > div": {
      color: Colors.rgb.contentTextSoft,
      fontSize: theme.fontSize.M,
    },
  },
  subscriptionItemWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  subscriptionItemDetails: {
    display: "flex",
    flexDirection: "column",
    width: "100%",

    "& > div": {
      display: "flex",
      alignItems: "center",
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentTextHighlighted,
      fontSize: theme.fontSize.L,

      "& > span": {
        margin: `0 ${theme.spacing(2)}`,
      },
    },
  },
  subscriptionItemExtraDetails: {
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentText,
    fontSize: `${theme.fontSize.M} !important`,
    marginTop: theme.spacing(1),

    "& span": {
      color: Colors.rgb.contentTextSoft,
      marginRight: theme.spacing(1),
    },

    "& > div:nth-child(even)": {
      color: Colors.rgb.contentTextSoft,
      margin: `0 ${theme.spacing(2)}`,
    },
  },
  subscriptionItemSeparator: {
    height: 1,
    width: "100%",
    background: Colors.rgb.contentLine,
  },
  additionalDataContainer: {
    marginBottom: theme.spacing(2),

    "&:last-child": {
      marginBottom: 0,
    },
  },
}));

export default makeClasses;
